import {
  Box,
  CircularProgress,
  Grid,
  makeStyles,
  MenuItem,
} from '@material-ui/core';
import PolicyNumberModal from 'components/AddNewContractModal/PolicyNumberModal';
import validationSchema from 'components/AddNewContractModal/validationSchema';
import { OrangeButton } from 'components/Button';
import InputField from 'components/InputField';
import messages from 'components/MenuItem/messages';
import { ColoredDivider, StyledGrid } from 'components/MenuItem/styles';
import SelectInputField from 'components/SelectInputField';
import { Captions } from 'components/Typography';
import { StyledBodyText } from 'containers/SignupPages/IdMemo/styles';
import HealthInsuranceFields from 'containers/SignupPages/PersonalInfo/HealthInsuranceFields';
import { FormikProps, withFormik } from 'formik';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import React, { useState } from 'react';
import { Info } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { PRIVILEGES } from 'utils/globalConst';
import { checkField, exactType } from 'utils/string';
import { handleSubmit } from './utils';

const useStyles = makeStyles({
  sizedInfoIcon: {
    width: 16,
    height: 16,
    marginBottom: -5,
    marginLeft: 2,
    marginRight: 2,
  },
  infoIcon: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(0,0,0,0.04)',
      borderRadius: '50%',
    },
  },
});

const AddConractForm = (
  props: {
    contractType: {
      type: string;
      value: string;
    }[];
    addNewContract: Function;
    handleClose: Function;
    productEpargn: [];
    setIsEpargn: Function;
    isLoadingProducts: boolean;
  } & FormikProps<FormValues>,
) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpenModal = /* istanbul ignore next */ () => {
    setOpen(true);
  };

  const handleCloseModal = /* istanbul ignore next */ () => {
    setOpen(false);
  };
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    contractType,
    productEpargn,
    setFieldValue,
  } = props;
  values.typeAssurance === PRIVILEGES.EPARGN && props.setIsEpargn(true);
  return (
    <form onSubmit={handleSubmit}>
      <Box paddingX={2}>
        <StyledBodyText>
          {translate({ ...messages.description }, props)}
        </StyledBodyText>
        <Box marginTop={3} marginBottom={3}>
          <Grid container direction="column" spacing={3} justify="center">
            <Grid item xs={12}>
              <SelectInputField
                name="typeAssurance"
                label={translate({ ...messages.typeAssurance }, props)}
                value={values.typeAssurance}
                handleChange={handleChange}
                handleBlur={handleBlur}
                labelId="select-typeAssurance"
                data={contractType}
                onChange={handleChange}
                SelectDisplayProps={{
                  id: 'select-id',
                  'data-testid': 'select-typeAssurance',
                }}
                Children={[...contractType]
                  .reverse()
                  .filter((contract: any) => contract.type !== 'ASI')
                  .map(
                    (item: { type: string; value: string }, index: number) => (
                      <MenuItem
                        data-testid={`option-typeAssurance-${index}`}
                        value={item.type}
                        key={index}
                      >
                        {item.value}
                      </MenuItem>
                    ),
                  )}
              />
            </Grid>
            {props.isLoadingProducts ? (
              <Grid container justify="center">
                <Grid item>
                  <CircularProgress data-testid="loader" />
                </Grid>
              </Grid>
            ) : (
              <>
                {values.typeAssurance === PRIVILEGES.EPARGN ? (
                  <Grid item xs={12}>
                    <SelectInputField
                      name="product"
                      label={translate(
                        { ...messages.selectionnezProduit },
                        props,
                      )}
                      value={values.product}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      data={productEpargn}
                      onChange={handleChange}
                      SelectDisplayProps={{
                        id: 'select-id2',
                        'data-testid': 'select-product',
                      }}
                      Children={[...productEpargn].map(
                        (
                          item: { value: string; label: string },
                          index: number,
                        ) => (
                          <MenuItem
                            data-testid="select-option-2"
                            value={item.value}
                            key={index}
                          >
                            {item.label}
                          </MenuItem>
                        ),
                      )}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {values.typeAssurance !== PRIVILEGES.AMC && (
                  <Grid item xs={12}>
                    <InputField
                      name="numPolice"
                      label={translate({ ...messages.numPolice }, props)}
                      value={values.numPolice}
                      error={errors.numPolice && touched.numPolice}
                      helperText={touched.numPolice && errors.numPolice}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      InputProps={{
                        'data-testid': 'input-numPolice',
                      }}
                      endAdornment={
                        <GaClickHOC
                          label="Besoin d'aide"
                          category={EVENT_CATEGORIES.ADD_CONTRACT}
                        >
                          <Info
                            className={classes.infoIcon}
                            onClick={
                              /* istanbul ignore next */ () => handleOpenModal()
                            }
                          />
                        </GaClickHOC>
                      }
                    />
                  </Grid>
                )}
                {values.typeAssurance === PRIVILEGES.EPARGN &&
                checkField(values.product, productEpargn)?.isPpr ? (
                  <Grid item xs={12}>
                    <InputField
                      name="ppr"
                      label={translate({ ...messages.ppr_field }, props)}
                      value={values.ppr}
                      error={errors.ppr && touched.ppr}
                      helperText={touched.ppr && errors.ppr}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      InputProps={{
                        'data-testid': 'input-ppr',
                      }}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {values.typeAssurance === PRIVILEGES.EPARGN &&
                checkField(values.product, productEpargn)?.isAdhesion ? (
                  <Grid item xs={12}>
                    <InputField
                      name="numAdhesion"
                      label={translate({ ...messages.numero_adhesion }, props)}
                      value={values.numAdhesion}
                      error={errors.numAdhesion && touched.numAdhesion}
                      helperText={touched.numAdhesion && errors.numAdhesion}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      InputProps={{
                        'data-testid': 'input-numAdhesion',
                      }}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {values.typeAssurance === PRIVILEGES.EPARGN &&
                checkField(values.product, productEpargn)?.isMatricule ? (
                  <Grid item xs={12}>
                    <InputField
                      name="matricule"
                      label={translate({ ...messages.matricule_field }, props)}
                      value={values.matricule}
                      error={errors.matricule && touched.matricule}
                      helperText={touched.matricule && errors.matricule}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      InputProps={{
                        'data-testid': 'input-matricule',
                      }}
                    />
                  </Grid>
                ) : (
                  <></>
                )}

                {values.typeAssurance === PRIVILEGES.EPARGN ? (
                  <Grid item xs={12}>
                    <InputField
                      name="dateEffet"
                      label={translate({ ...messages.dateEffet }, props)}
                      value={values.dateEffet}
                      type="date"
                      placeholder={translate({ ...messages.dateEffet }, props)}
                      error={errors.dateEffet && touched.dateEffet}
                      helperText={touched.dateEffet && errors.dateEffet}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        'data-testid': 'date-effet',
                        inputProps: { max: '9999-12-30' },
                      }}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {values.typeAssurance === PRIVILEGES.AMC && (
                  <Grid item xs={12}>
                    <HealthInsuranceFields
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      organization={values.organization}
                      membershipNumber={values.membershipNumber}
                      drpp={values.drpp}
                      touched={touched}
                      errors={errors}
                    />
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Box>

        <Captions weight="400" color="#9197A3">
          {translate({ ...messages.helpMessage }, props, {
            infoIcon: <Info className={classes.sizedInfoIcon} />,
          })}
        </Captions>
      </Box>
      <ColoredDivider orientation="horizontal" />
      <StyledGrid spacing={5} container justify="flex-end">
        <Grid item>
          <GaClickHOC label="Annuler" category={EVENT_CATEGORIES.ADD_CONTRACT}>
            <OrangeButton onClick={props.handleClose}>
              {translate({ ...messages.cancel }, props)}
            </OrangeButton>
          </GaClickHOC>
        </Grid>
        <Grid item>
          <GaClickHOC label="Valider" category={EVENT_CATEGORIES.ADD_CONTRACT}>
            <OrangeButton
              data-testid="button-submit"
              type="submit"
              variant="contained"
            >
              {translate({ ...messages.valid }, props)}
            </OrangeButton>
          </GaClickHOC>
        </Grid>
      </StyledGrid>
      <PolicyNumberModal
        open={open}
        handleOpen={handleOpenModal}
        handleClose={handleCloseModal}
        typeAssurance={values.typeAssurance}
      />
    </form>
  );
};

export interface FormProps extends RouteComponentProps {
  intl: IntlShape;
  contractType: {
    type: string;
    value: string;
  }[];
  addNewContract: Function;
  handleClose: Function;
  productEpargn: [];
  setIsEpargn: Function;
  isLoadingProducts: boolean;
}

interface FormValues {
  typeAssurance: string;
  numPolice: string;
  product: string;
  dateEffet: string;
  matricule: string;
  numAdhesion: string;
  ppr: string;
  organization: any;
  drpp: string;
  membershipNumber: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: ({ location }) => {
    return {
      typeAssurance: exactType(location.pathname.slice(1)),
      numPolice: '',
      product: '197',
      dateEffet: '',
      matricule: '',
      numAdhesion: '',
      ppr: '',
      organization: null,
      drpp: '',
      membershipNumber: '',
      cin: '',
    };
  },
  validationSchema,
  handleSubmit,
})(AddConractForm);

export default injectIntl(withRouter(Form));
